<template>
  <div>
    <v-toolbar dense color="highlight" dark flat class="sticky">
      <v-toolbar-title>{{$t('myTodos')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
      <dataTable v-on:clickItem="editBlueprint" :items="todo" :progress="progress" :headers="headers">
        <template v-slot:itemOpenMarkers="{item}">
          <v-chip
            :color="item.markers == 0 ? 'success' : 'primary'"
            dark
          >{{ item.markers }} {{$t('markers')}}</v-chip>
        </template>
        <template v-slot:itemAction="{item}">
          <v-btn color="primary" :disabled="item.isLocked" icon @click.stop="editBlueprint(item)">
            <v-icon color="primary">fa-edit</v-icon>
          </v-btn>
        </template>
        <template v-slot:cardContent="{item}">
          <v-subheader class="primary lighten-3 white--text font-weight-bold">
            <a href="#" class="white--text" @click="editBlueprint(item)">{{item.blueprint }}</a>
            <v-spacer></v-spacer>
          </v-subheader>

          <v-divider></v-divider>
          <div v-ripple class="pointer" @click="editBlueprint(item)">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>{{$t('project')}}:</v-list-item-content>
                <v-list-item-content
                  class="align-end font-weight-bold text-truncate"
                >{{ item.project }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>{{$t('buildingComponent')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.buildingComponent }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{$t('todo')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">
                  <div>
                    <v-chip
                      :color="item.markers == 0 ? 'success' : 'primary'"
                      dark
                    >{{ item.markers }} {{$t('markers')}}</v-chip>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="item.isLocked">
                <v-list-item-content>{{$t('isEditing')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.lockedByUserName }}</v-list-item-content>
              </v-list-item>
              <v-list-item v-if="item.isLocked">
                <v-list-item-content>{{$t('editStart')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.lockedTs }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </template>
        <template v-slot:empty>
          <retry v-on:retry="getData()" v-if="retry"></retry>
          <emptyList
            fit
            :image="require('@/assets/blueprint_logo_low_opacity.png')"
            :title="$t('noBlueprints')"
            v-else
          >
            <template v-slot:action>
              <can I="create" a="blueprints">
                <addBlueprint v-on:add-blueprint="addBlueprint"></addBlueprint>
              </can>
            </template>
          </emptyList>
        </template>
      </dataTable>
    </div>
    <v-dialog v-model="dialog" persistent max-width="290">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title class="headline">{{$t('warning')}}</v-card-title>
        <v-card-text>{{$t('continuereadonly')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text autofocus @click="responseReadonly(false)">{{$t('no')}}</v-btn>
          <v-btn color="primary" text @click="responseReadonly(true)">{{$t('yes')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import jwtdecode from "jwt-decode";
import dataTable from "@/components/Datatable";
export default {
  name: "Todo",
  components: {
    dataTable
  },
  data() {
    return {
      todo: [],
      // reports: [],
      progress: true,
      headers: [],
      response: false,
      dialog: false,
      readonlyblueprint: null
    };
  },

  methods: {
    blueprintDetails(item) {
      //will be redirected anyways to readonly if not allowed
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: { id: item.id }
      });
    },
    markerDetails(item) {
      this.$router.push({
        name: "MarkerDetails",
        params: { id: item.markerId }
      });
    },
    editBlueprint(item) {
      if (this.$can("update", "markers")) {
        if (
          jwtdecode(localStorage.getItem("auth")).contactId !=
          item.lockedByUserId
        ) {
          this.$http
            .lockBlueprint(item.id)
            .then(res => {
              if (item.lockedByUserName !== null) {
                this.dialog = true;
                this.readonlyblueprint = item;
              } else {
                this.blueprintDetails(item, true);
              }
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
        } else {
          this.blueprintDetails(item, true);
        }
      } else {
        this.blueprintDetails(item, false);
      }
    },
    responseReadonly(yes) {
      if (yes) {
        this.dialog = false;
        if (this.readonlyblueprint)
          this.blueprintDetails(this.readonlyblueprint, true);
      }
      this.readonlyblueprint = null;
      this.dialog = false;
    }
  },
  watch: {
    todo(n, o) {
      if (n.length > 0) {
        if (n.some(x => x.isLocked)) {
          this.headers = [
            {
              text: this.$t("project"),
              align: "left",
              value: "project"
            },
            {
              text: this.$t("buildingComponent"),
              align: "left",
              value: "buildingComponent"
            },
            {
              text: this.$t("blueprint"),
              align: "left",
              value: "blueprint"
            },
            {
              text: this.$t("deadline"),
              align: "left",
              value: "deadline"
            },
            {
              text: this.$t("isEditing"),
              value: "lockedByUserName"
            },
            {
              text: this.$t("editStart"),
              value: "lockedTs"
            },
            {
              text: this.$t("todo"),
              align: "left",
              value: "markers"
            },
            { text: this.$t("actions"), sortable: false, value: "actions" }
          ];
        } else {
          this.headers = [
            {
              text: this.$t("project"),
              align: "left",
              value: "project"
            },
            {
              text: this.$t("buildingComponent"),
              align: "left",
              value: "buildingComponent"
            },
            {
              text: this.$t("blueprint"),
              align: "left",
              value: "blueprint"
            },
            {
              text: this.$t("deadline"),
              align: "left",
              value: "deadline"
            },
            {
              text: this.$t("todo"),
              align: "left",
              value: "markers"
            },
            { text: this.$t("actions"), sortable: false, value: "actions" }
          ];
        }
      }
    }
  },
  created() {
    this.$http
      .getTodo()
      .then(res => {
        this.todo = res.data;
        this.progress = false;
      })
      .catch(err => {
        this.progress = false;
        console.log(err);
      });
    this.$store.state.previous = null;
  }
};
</script>


// WEBPACK FOOTER //
// src/views/todo/Index.vue